import { useLabels } from '../../i18n/labels';
import { BADGE_XS } from './badgeSize';

interface RoleBadgeProps {
  role: string;
  /** `xs` is the compact badge of a dense row (`BADGE_XS`). */
  size?: 'xs' | 'sm';
  className?: string;
}

export default function RoleBadge({ role, size = 'sm', className = '' }: RoleBadgeProps) {
  // #531 — the role from the translations; `capitalize` made "Vyr. Treneris".
  const { roleLabel } = useLabels();
  return (
    <span data-testid="role-badge" className={`badge badge-gray text-xs ${size === 'xs' ? BADGE_XS : ''} ${className}`}>
      {roleLabel(role)}
    </span>
  );
}
